import { useState } from 'react'
import { useAuthStore } from '../../store/authStore'
import { mediaUrl } from '../../utils/media'
import { useReportComment } from '../../api/useComments'
import { getErrMsg } from '../../api/client'
import { formatDateComment as formatDate } from '../../utils/date'
import toast from 'react-hot-toast'

export default function CommentItem({ comment, onDelete, onReact, onReply, isReply = false }) {
  const user = useAuthStore((s) => s.user)
  const isAuth = useAuthStore((s) => s.isAuth)
  const isOwn = user?.id === comment.user_id || user?.id === comment.author?.id
  const [reportOpen, setReportOpen] = useState(false)
  const [reportReason, setReportReason] = useState('')
  const { mutate: report, isPending: reporting } = useReportComment()

  const handleReact = (type) => {
    if (!isAuth) { toast.error('Войдите, чтобы оценить комментарий'); return }
    onReact(comment.id, type)
  }

  const handleReport = (e) => {
    e.preventDefault()
    if (!reportReason.trim()) return
    report({ commentId: comment.id, reason: reportReason.trim() }, {
      onSuccess: () => { toast.success('Жалоба отправлена'); setReportOpen(false); setReportReason('') },
      onError: (err) => {
        const msg = getErrMsg(err)
        if (msg === 'Вы уже отправили жалобу на этот комментарий') toast.error(msg)
        else toast.error('Ошибка при отправке жалобы')
      },
    })
  }

  const liked = comment.user_reaction === 'like'
  const disliked = comment.user_reaction === 'dislike'

  return (
    <div className="flex gap-3 p-4 rounded-xl bg-surface">
      <div className="w-9 h-9 rounded-full overflow-hidden flex items-center justify-center text-xs font-bold shrink-0 bg-surface2 text-accent">
        {comment.author?.avatar_url
          ? <img src={mediaUrl(comment.author.avatar_url)} alt="" className="w-full h-full object-cover" />
          : (comment.author?.username || '?').slice(0, 2).toUpperCase()}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2 mb-1">
          <span className="text-sm font-semibold">{comment.author?.username || 'Аноним'}</span>
          <span className="text-xs text-muted shrink-0">{formatDate(comment.created_at)}</span>
        </div>

        <p className="text-sm leading-relaxed text-fg">{comment.text}</p>

        <div className="flex items-center gap-3 mt-2">
          <button
            onClick={() => handleReact('like')}
            className={`flex items-center gap-1 text-xs transition-colors hover:text-fg ${liked ? 'text-accent' : 'text-muted'}`}
            title="Нравится"
          >
            <span className="text-sm">👍</span>
            {comment.likes_count > 0 && <span className="font-medium">{comment.likes_count}</span>}
          </button>

          <button
            onClick={() => handleReact('dislike')}
            className={`flex items-center gap-1 text-xs transition-colors hover:text-fg ${disliked ? 'text-red-400' : 'text-muted'}`}
            title="Не нравится"
          >
            <span className="text-sm">👎</span>
            {comment.dislikes_count > 0 && <span className="font-medium">{comment.dislikes_count}</span>}
          </button>

          {isAuth && !isReply && onReply && (
            <button
              onClick={() => onReply(comment.id)}
              className="text-xs text-muted hover:text-fg transition-colors"
            >
              Ответить
            </button>
          )}

          {isAuth && !isOwn && (
            <button
              onClick={() => setReportOpen((v) => !v)}
              className="text-xs text-muted hover:text-amber-400 transition-colors"
              title="Пожаловаться"
            >
              Жалоба
            </button>
          )}

          {isOwn && (
            <button
              onClick={() => onDelete(comment.id)}
              className="text-xs text-muted hover:text-red-400 transition-colors ml-auto"
            >
              Удалить
            </button>
          )}
        </div>

        {reportOpen && (
          <form onSubmit={handleReport} className="mt-3 flex gap-2">
            <input
              value={reportReason}
              onChange={(e) => setReportReason(e.target.value)}
              placeholder="Причина жалобы..."
              className="flex-1 px-3 py-1.5 rounded-lg text-xs outline-none bg-surface2 border border-line text-fg focus:border-accent transition-colors"
            />
            <button type="submit" disabled={reporting || !reportReason.trim()}
              className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-amber-400/20 text-amber-400 hover:bg-amber-400/30 disabled:opacity-50 transition-colors">
              Отправить
            </button>
            <button type="button" onClick={() => setReportOpen(false)}
              className="px-2 py-1.5 rounded-lg text-xs text-muted hover:text-fg transition-colors">
              ✕
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
